package com.upcominds.expedite.data

import com.upcominds.expedite.dto.ApiError
import kotlinx.serialization.json.Json

class ApiException(
    val statusCode: Int,
    override val message: String,
    val responseBody: String? = null,
    cause: Throwable? = null
) : Exception(message, cause)

private val errorJson = Json {
    ignoreUnknownKeys = true
    isLenient = true
}

private val genericMessages = setOf(
    "forbidden",
    "unauthorized",
    "access denied",
    "null"
)

fun mapApiError(statusCode: Int, bodyText: String?, requestUrl: String? = null): String {
    val backendMessage = parseBackendMessage(bodyText)
    val fallback = statusFallback(statusCode, requestUrl)

    return if (backendMessage.isNullOrBlank() || backendMessage.trim().lowercase() in genericMessages) {
        fallback
    } else {
        backendMessage
    }
}

private fun parseBackendMessage(bodyText: String?): String? {
    val raw = bodyText?.trim().orEmpty()
    if (raw.isBlank()) return null
    if (raw.startsWith("<")) return null

    val fromDto = runCatching {
        errorJson.decodeFromString<ApiError>(raw).message
    }.getOrNull()
    if (!fromDto.isNullOrBlank()) return fromDto

    return "\"message\"\\s*:\\s*\"([^\"]+)\"".toRegex()
        .find(raw)
        ?.groupValues
        ?.getOrNull(1)
}

private fun statusFallback(statusCode: Int, requestUrl: String?): String =
    when (statusCode) {
        400 -> "The request was invalid. Please check your data and try again."
        401 -> "Your session has expired. Please sign in again."
        403 -> {
            if (requestUrl?.contains("/api/admin/") == true) {
                "You don't have admin access for this section."
            } else {
                "You don't have permission to access this section."
            }
        }
        404 -> "The requested resource was not found."
        409 -> "This action conflicts with existing data."
        422 -> "Some fields are invalid. Please review and try again."
        in 500..599 -> "Server error. Please try again later."
        else -> "Request failed (HTTP $statusCode). Please try again."
    }
